<p-toast></p-toast>

<p-dialog class="area-not-active-dialog" [(visible)]="isVisibleAreaNotActiveModal" *ngIf="isVisibleAreaNotActiveModal"
          [modal]="true" [draggable]="false" [resizable]="false">
    <div class="m-0 suspend-body">
        <p class="suspend-title">This area is not yet active.</p>
    </div>
</p-dialog>

<!--<div class="xpress-sidebar col-2"
     [ngClass]="{
    'xpress-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'xpress-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic}">
    <div style="margin-top: 20px">
        <img src="/Content/xpress-app/images/xpress_logo_black.svg" style="width: 114px" *ngIf="!appData.boracayEnvironment" />
        <img src="/Content/xpress-app/images/logo_aklan.png" style="width: 114px" *ngIf="appData.boracayEnvironment" />
    </div>

    <div style="margin-top: 10px; margin-bottom: 14px" *ngIf="!appData.boracayEnvironment">
        <p-dropdown [options]="geoZones"
                    [optionLabel]="'Name'"
                    [(ngModel)]="_selectGeoZone"
                    [style]="{width: '100%', background: '#FFF'}"></p-dropdown>
    </div>

    <ng-content></ng-content>
</div>-->
